(() => {
  'use strict';
  const campaignKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'];
  function prepare(root) {
    if (root.dataset.landingReady) return;
    root.dataset.landingReady = 'true';
    const incoming = new URLSearchParams(window.location.search);
    root.querySelectorAll('[data-dc-design]').forEach(link => {
      const destination = new URL(link.getAttribute('href'), window.location.origin);
      const allowed = destination.origin === window.location.origin || destination.origin === 'https://leisurelounges.com.au';
      if (allowed) {
        for (const key of campaignKeys) {
          const value = incoming.get(key);
          if (value && value.length <= 300) destination.searchParams.set(key, value);
        }
        destination.searchParams.set('dc_source', 'dreamcoat-social');
        link.href = destination.href;
      }
      link.addEventListener('click', () => {
        // The store can connect this event to its existing consent-aware analytics.
        // This page does not install trackers or send contact details.
        root.dispatchEvent(new CustomEvent('dreamcoat:landing-action', {
          bubbles: true,
          detail: { action: 'open_customiser', placement: link.dataset.dcDesign, source: 'dreamcoat-social' }
        }));
      });
    });
    const dock = root.querySelector('.dc-mobile-action');
    if (dock && 'IntersectionObserver' in window) {
      const visibleActions = new Set();
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.8) visibleActions.add(entry.target);
          else visibleActions.delete(entry.target);
        }
        dock.hidden = visibleActions.size > 0;
      }, { threshold: [0, 0.8, 1], rootMargin: '0px 0px -80px 0px' });
      root.querySelectorAll('[data-dc-design]:not(.dc-mobile-action [data-dc-design])').forEach(link => observer.observe(link));
    }
  }
  document.querySelectorAll('[data-dreamcoat-landing]').forEach(prepare);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-dreamcoat-landing]').forEach(prepare);
  });
})();
